export const getPathFromUrl = (url: string): string => url.split('?')[0]
